<template>
  <div class="pager" :style="`width:${width}`">
    <div class="pager-container" v-if="!isLoading">
      <div class="pager-first-page" v-if="!onlySingleSteps">
        <b-btn class="btn-icon mono" @click="gotoFirstPage" :disabled="onFirstPage"><i class="mdp-PagingFirstLeft"></i></b-btn>
      </div>
      <div class="pager-prev-page">
        <b-btn class="btn-icon mono" @click="gotoPrevPage" :disabled="onFirstPage"><i class="mdp-PagingLeft"></i></b-btn>
      </div>
      <b-form-input
        :value="intern_currentPage"
        @change="pageChange"
        :readonly="buttonOnlyNavigation"
        v-if="!currentPage && !buttonOnlyNavigation"></b-form-input>
      <span class="current-page-label" v-else>{{ currentPage || intern_currentPage }}</span>
      <span class="max-page-number" v-if="showPageCount">/</span>
      <span class="max-page-number" v-if="showPageCount">{{ pageCount }}</span>
      <div class="pager-next-page">
        <b-btn class="btn-icon mono" @click="gotoNextPage" :disabled="onLastPage"><i class="mdp-PagingRight"></i> </b-btn>
      </div>
      <div class="pager-last-page" v-if="!onlySingleSteps">
        <b-btn class="btn-icon mono" @click="gotoLastPage" :disabled="onLastPage"><i class="mdp-PagingLastRight"></i></b-btn>
      </div>
    </div>
    <div v-else>
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import Spinner from "./Spinner.vue";
export default {
  components: { Spinner },
  props: {
    onlySingleSteps: { type: Boolean, default: false }, //Removes jump to "First- and Last" Button
    firstPage: { type: [String, Number], default: 1 }, //Defines Where the pagination Starts
    pageCount: { type: [String, Number] }, //Defines Where the pagination ends
    buttonOnlyNavigation: { type: Boolean, default: false }, // Disabled the possibility to Enter a Page Number to Jump to
    isLoading: { type: Boolean, default: false }, // Defines if it is loading or not
    showPageCount: { type: Boolean, default: false }, //Show how many pages there are

    isOnFirstPage: { type: Boolean, default: false }, // Overrides the Check for the First Page only if "currentPage" is provided
    isOnLastPage: { type: Boolean, default: false }, // Overrides the Check for the Last Page only if "currentPage" is provided
    currentPage: { type: Number }, //Set the CurrentPage manually. Disables checkups for Boundaries.

    width: { type: String, default: "fit-content" } //Sets the specific width of the pager
  },
  data() {
    return { intern_currentPage: this.firstPage };
  },
  methods: {
    gotoFirstPage() {
      this.$emit("first-page");
      if (!this.currentPage) {
        this.pageChange(this.firstPage);
      }
    },
    gotoPrevPage() {
      this.$emit("prev-page");
      if (!this.currentPage) {
        this.pageChange(this.intern_currentPage - 1);
      }
    },
    gotoNextPage() {
      this.$emit("next-page");
      if (!this.currentPage) {
        this.pageChange(this.intern_currentPage + 1);
      }
    },
    gotoLastPage() {
      this.$emit("last-page");
      if (!this.currentPage) {
        this.pageChange(this.pageCount);
      }
    },
    pageChange(newPage) {
      if (!this.currentPage) {
        const oldPageValue = this.intern_currentPage.valueOf();
        this.validateAndSet(parseInt(newPage));
        const eventData = {
          pageChangeTo: this.intern_currentPage,
          onFirstPage: this.onFirstPage,
          onLastPage: this.onLastPage,
          direction: this.intern_currentPage - oldPageValue
        };
        this.$emit("page-changed", eventData);
      }
    },
    validateAndSet(newPage) {
      if (newPage < this.firstPage) {
        this.intern_currentPage = this.firstPage;
      }
      if (newPage > this.pageCount) {
        this.intern_currentPage = this.pageCount;
      }
      this.intern_currentPage = newPage;
    }
  },
  computed: {
    onFirstPage() {
      if (this.currentPage) {
        return this.isOnFirstPage;
      }
      return this.intern_currentPage == this.firstPage;
    },
    onLastPage() {
      if (this.currentPage) {
        return this.isOnLastPage;
      }
      return this.intern_currentPage == this.pageCount;
    }
  }
};
</script>
